import { Button } from '@cian/ui-kit/button';
import * as React from 'react';

import { SaveSearchModalContainer } from '../SaveSearchModalContainer';

export const SubscribeButtonContainer: React.FC = () => {
  const [open, setOpenModal] = React.useState<boolean>(false);

  const openModal = () => {
    setOpenModal(true);
  };

  const closeModal = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Button size="XS" theme="fill_secondary" onClick={openModal}>
        Подписаться на дом
      </Button>
      <SaveSearchModalContainer open={open} onClose={closeModal} />
    </>
  );
};
